import { CalendarFiltersState } from '../state/calendar-filter/state';
import { CalendarGridColumnLabel } from '../grid/types/column.types';
import { DealVersionSelector } from './deal.types';

export const DEFAULT_FLEX_COLUMN = CalendarGridColumnLabel.Sector;
export const DEFAULT_MARGINAL_TAX_RATE = '35';
export const DEFAULT_CALENDAR_FOLLOW_ASSIGNMENT_SHORTCUT = 'true';

export interface DealManagerView {
  type: DealManagerViewType;
  options: {
    trackingOptions: boolean;
    assignments: boolean;
  };
}

export enum DealManagerViewType {
  internal = 'Internal',
  structure = 'Structure'
}
export const DEFAULT_DEAL_MANAGER_VIEW = {
  type: DealManagerViewType.internal,
  options: {
    trackingOptions: true,
    assignments: true
  }
};

export enum BenchmarkCurveIdentifier {
  MmdInterpolated = 'MMD Interpolated',
  MmdCurrent = 'MMD Current',
  MmdAaaInsured = 'MMD AAA Insured',
  MmdAa = 'MMD AA',
  MmdA = 'MMD A',
  MmdBaa = 'MMD BAA',
  MmdPreRe = 'MMD Pre-Re',
  MacInterpolated = 'MAC Interpolated',
  MacCurrent = 'MAC Current',
  IceAaa = 'ICE AAA'
}

export interface BenchmarkMMDCurve {
  seriesId: number;
  curveSelected: BenchmarkCurveIdentifier;
}

export const DEFAULT_CALENDAR_RATINGS_VIEW = 'Deal';
export interface UserPreferences {
  defaultFlexColumn: CalendarGridColumnLabel;
  defaultBenchmarkCurve: BenchmarkCurveIdentifier;
  defaultMarginalTaxRate: string;
  defaultCalendarFollowShortcut?: boolean;
  defaultDealManagerView: DealManagerView;
  defaultDealVersions: {
    competitive: DealVersionSelector;
    negotiated: DealVersionSelector;
  };
  defaultCalendarRatingsView: string;
}

export class UserPreference {
  id: string;
  name: string;
  userPreference: any;
}

export class FilterSet {
  id: string;
  name: string;
  filterSet: Partial<CalendarFiltersState>;
}
